export const ACTION_RECEIVE_COURSES = 'RECEIVE_COURSES';
export const ACTION_SELECT_PLAYER = 'SELECT_PLAYER';
export const ACTION_ADD_PLAYER = 'ADD_PLAYER';
export const ACTION_RECEIVE_PLAYERS = 'RECEIVE_PLAYERS';
export const ACTION_RECEIVE_COURSES_FROM_SEARCH = 'RECEIVE_COURSES_FROM_SEARCH';
export const ACTION_RECEIVE_PLAYERS_FROM_SEARCH = 'RECEIVE_PLAYERS_FROM_SEARCH';
export const ACTION_SELECT_COURSE = 'SELECT_COURSE';
export const ACTION_ACTIVATE_PLAYERS_TAB = 'ACTIVATE_PLAYERS_TAB';
export const ACTION_ACTIVATE_COURSE_TAB = 'ACTIVATE_COURSE_TAB';
export const ACTION_OPEN_SEARCHBAR = 'OPEN_SEARCHBAR';
export const ACTION_CLEAR_SEARCH = 'CLEAR_SEARCH';
export const ACTION_DISABLE_START_GAME_BUTTON = 'DISABLE_START_GAME_BUTTON';
export const ACTION_ACTIVATE_SEARCH = 'ACTIVATE_SEARCH';
export const ACTION_SHOW_LOADING_INDICATOR = 'SHOW_LOADING_INDICATOR';
export const ACTION_HIDE_LOADING_INDICATOR = 'HIDE_LOADING_INDICATOR';

export const ACTION_CREATE_NEW_USER_FORM_SHOW_FORM = 'CREATE_NEW_USER_FORM_SHOW_FORM';
export const ACTION_CREATE_NEW_USER_FORM_HIDE_FORM = 'CREATE_NEW_USER_FORM_HIDE_FORM';
export const ACTION_CREATE_NEW_USER_FORM_SHOW_ERRORS = 'CREATE_NEW_USER_FORM_SHOW_ERRORS';
export const ACTION_CREATE_NEW_USER_FORM_HIDE_ERRORS = 'CREATE_NEW_USER_FORM_HIDE_ERRORS';

export const receiveCourses = courses => ({
    type: ACTION_RECEIVE_COURSES,
    courses,
});

export const selectPlayer = player => ({
    type: ACTION_SELECT_PLAYER,
    player,
});

export const addPlayer = player => ({
    type: ACTION_ADD_PLAYER,
    player,
});

export const receivePlayers = players => ({
    type: ACTION_RECEIVE_PLAYERS,
    players,
});

export const receiveCoursesFromSearch = courses => ({
    type: ACTION_RECEIVE_COURSES_FROM_SEARCH,
    courses,
});

export const receivePlayersFromSearch = players => ({
    type: ACTION_RECEIVE_PLAYERS_FROM_SEARCH,
    players,
});

export const selectCourse = courseId => ({
    type: ACTION_SELECT_COURSE,
    courseId,
});

export const activatePlayersTab = () => ({
    type: ACTION_ACTIVATE_PLAYERS_TAB,
});

export const activateCourseTab = () => ({
    type: ACTION_ACTIVATE_COURSE_TAB,
});

export const openSearchbar = () => ({
    type: ACTION_OPEN_SEARCHBAR,
});

export const clearSearch = () => ({
    type: ACTION_CLEAR_SEARCH,
});

export const disableStartingGame = () => ({
    type: ACTION_DISABLE_START_GAME_BUTTON,
});

export const activateSearch = (queryType, query) => ({
    type: ACTION_ACTIVATE_SEARCH,
    query,
    queryType,
});

export const hideLoadingIndicator = () => ({
    type: ACTION_HIDE_LOADING_INDICATOR,
});

export const showLoadingIndicator = () => ({
    type: ACTION_SHOW_LOADING_INDICATOR,
});

export const createNewUserFormShowForm = () => ({
    type: ACTION_CREATE_NEW_USER_FORM_SHOW_FORM,
});

export const createNewUserFormHideForm = () => ({
    type: ACTION_CREATE_NEW_USER_FORM_HIDE_FORM,
});

export const createNewUserFormHideErrors = () => ({
    type: ACTION_CREATE_NEW_USER_FORM_HIDE_ERRORS,
});

export const createNewUserFormShowErrors = error => ({
    type: ACTION_CREATE_NEW_USER_FORM_SHOW_ERRORS,
    error,
});



// WEBPACK FOOTER //
// ./src/apps/create_game/actions.js